import {ALERT_TEMPLATE_LINKS} from "./constants";
export const AlertTemplateData = {
  'template:1': {
    id: 1,
    name: 'Full Page',
    templateReqHeading: false,
    templateReqMessage: true,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_1,
    firmwareVersion: "1.1.8",
    maxAlertMessageCharacter:200,
    maxAlertTitleCharacter:0,
    maxAlertMessageLine:8,
  },
  'template:2': {
    id: 2,
    name: 'Lower Left icon with Text',
    templateReqHeading: true,
    templateReqMessage: true,
    templateReqIcon: true,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_2,
    firmwareVersion: "1.1.8",
    maxAlertMessageCharacter:200,
    maxAlertTitleCharacter:20,
    maxAlertMessageLine:4,
  },
  'template:3': {
    id: 3,
    name: 'Small Lower Ticker',
    templateReqHeading: true,
    templateReqMessage: true,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_3,
    firmwareVersion: "1.1.8",
    maxAlertMessageCharacter:2100,
    maxAlertTitleCharacter:32,
    maxAlertMessageLine:1,
  },
  'template:4': {
    id: 4,
    name: 'Mimo Lower Right Icon, No Text',
    templateReqHeading: false,
    templateReqMessage: false,
    templateReqIcon: false,
    templateReqLogo: true,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_4,
    firmwareVersion: "1.1.8",
    maxAlertMessageCharacter:0,
    maxAlertTitleCharacter:0,
    maxAlertMessageLine:0,
  },
  'template:12': {
    id: 12,
    name: 'Yellow Three Line Lower Banner',
    templateReqHeading: false,
    templateReqMessage: true,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_12,
    firmwareVersion: "1.1.8",
    maxAlertMessageCharacter:225,
    maxAlertTitleCharacter:0,
    maxAlertMessageLine:3,
  },
  'template:13': {
    id: 13,
    name: 'IP Address',
    templateReqHeading: false,
    templateReqMessage: false,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_13,
    firmwareVersion: "1.2.9",
    maxAlertMessageCharacter:0,
    maxAlertTitleCharacter:0,
    maxAlertMessageLine:0,
  },
  'template:14': {
    id: 14,
    name: 'Large Top Ticker',
    templateReqHeading: false,
    templateReqMessage: true,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_14,
    firmwareVersion: "1.2.6",
    maxAlertMessageCharacter:2100,
    maxAlertTitleCharacter:0,
    maxAlertMessageLine:1,
  },
  'template:15': {
    id: 15,
    name: 'Shelter in Place Emergency',
    templateReqHeading: false,
    templateReqMessage: true,
    templateReqIcon: true,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_15,
    firmwareVersion: "1.2.9",
    maxAlertMessageCharacter:500,
    maxAlertTitleCharacter:0,
    maxAlertMessageLine:8,
  },
  'template:16': {
    id: 16,
    name: 'Bus Arrival',
    templateReqHeading: false,
    templateReqMessage: true,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_16,
    firmwareVersion: "1.2.9",
    maxAlertMessageCharacter:200,
    maxAlertTitleCharacter:20,
    maxAlertMessageLine:4,
  },
  'template:17': {
    id: 17,
    name: 'Weather',
    templateReqHeading: false,
    templateReqMessage: false,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: true,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_17,
    firmwareVersion: "1.2.9",
    maxAlertMessageCharacter:0,
    maxAlertTitleCharacter:0,
    maxAlertMessageLine:0,
  },
  'template:18': {
    id: 18,
    name: 'All Clear Notice',
    templateReqHeading: false,
    templateReqMessage: false,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: true,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_18,
    firmwareVersion: "1.3.1",
    maxAlertMessageCharacter:500,
    maxAlertTitleCharacter:0,
    maxAlertMessageLine:8,
  },
  'template:19': {
    id: 19,
    name: 'Full Screen Extra Large Text',
    templateReqHeading: false,
    templateReqMessage: false,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: true,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_19,
    firmwareVersion: "1.3.1",
    maxAlertMessageCharacter:500,
    maxAlertTitleCharacter:0,
    maxAlertMessageLine:8,
  },
  'template:20': {
    id: 20,
    name: 'All Text',
    templateReqHeading: true,
    templateReqMessage: true,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_20,
    firmwareVersion: "1.3.1",
    maxAlertMessageCharacter:500,
    maxAlertTitleCharacter:64,
    maxAlertMessageLine:16,
  },
  'template:21': {
    id: 21,
    name: 'All Text',
    templateReqHeading: true,
    templateReqMessage: true,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_1,
    firmwareVersion: "1.3.1",
    maxAlertMessageCharacter:500,
    maxAlertTitleCharacter:64,
    maxAlertMessageLine:16,
  },
  'template:22': {
    id: 22,
    name: 'All Text',
    templateReqHeading: true,
    templateReqMessage: true,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_20,
    firmwareVersion: "1.3.1",
    maxAlertMessageCharacter:500,
    maxAlertTitleCharacter:64,
    maxAlertMessageLine:16,
  },
  'template:23': {
    id: 23,
    name: 'All Text',
    templateReqHeading: true,
    templateReqMessage: true,
    templateReqIcon: false,
    templateReqLogo: false,
    templateReqZipCode: false,
    orgIds: [],
    image: ALERT_TEMPLATE_LINKS.TEMPLATE_20,
    firmwareVersion: "1.3.1",
    maxAlertMessageCharacter:500,
    maxAlertTitleCharacter:64,
    maxAlertMessageLine:16,
  },
};
